<template>
  <div class="etg-radio-group w-full scrollbar">
    <n-radio-group v-model:value="modelValue" class="w-full">
      <template v-for="item in props.options" :key="item.id">
        <div class="radio-item hover:bg-gray-20 transition-colors" :class="props.itemClass">
          <n-radio class="w-full px-5 py-3" :value="item.id!" :label="item.name" @click="handleRadioClick(item.id!)" />
        </div>
        <slot :item="item" />
      </template>
    </n-radio-group>
    <scroll-mask v-if="isMaskShown" />
  </div>
</template>

<script setup lang="ts" generic="T extends { id?: Nullable<string | number>; name?: string }">
import { NRadioGroup, NRadio } from 'naive-ui'

interface Props {
  options?: T[]
  cancelable?: boolean
  itemClass?: string
  isMaskShown?: boolean
}

const modelValue = defineModel<Nullable<string | number>>()

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  cancelable: false,
  itemClass: '',
  isMaskShown: false,
})

const handleRadioClick = (val: string | number) => {
  if (props.cancelable && modelValue.value === val) modelValue.value = null
}
</script>
